import { useSo5Competitions } from 'hooks/useSo5Competitions';

export const useCompetitionEligibilityFilterValue = (
  competitionEligibilityFilter: string | undefined
) => {
  const { filterableSo5Competitions } = useSo5Competitions();

  if (!competitionEligibilityFilter || !filterableSo5Competitions) return null;

  return filterableSo5Competitions.find(
    s => s.slug === competitionEligibilityFilter
  )?.algoliaFilters;
};
